import React from "react";

import './rules.scss';

const Rules = ({ handleRulesClick}) => {
    return(
        <>
            <div className="rules_container">
                <div className="outer" onClick={handleRulesClick}>
                      <div className="inner">
                        <label className='label_class' >назад</label>
                      </div>
                </div>
                <div className="text_rules">
                    <h3>Правила посещения студии для музыкальных репетиций</h3>
                    <ol>
                        <li>
                        <strong>Запись и бронирование времени:</strong>
                        <ul>
                            <li>Репетиции необходимо бронировать заранее через онлайн-систему или по телефону +73912012884.</li>
                            <li>Запись подтверждается только после звонка администратора.</li>
                            <li>Все отмены должны быть сделаны не позднее чем за 24 часа до начала репетиции, иначе взимается штраф 50%.</li>
                            <li>Время репетиции начинается с момента, занятого вами времени и заканчивается по времени, указанному при бронировании.</li>
                        </ul>
                        </li>
                        <li>
                        <strong>Пунктуальность:</strong>
                        <ul>
                            <li>Просьба приходить заранее. Если вы опоздали, репетиция сокращается на это время.</li>
                        </ul>
                        </li>
                        <li>
                        <strong>Использование оборудования:</strong>
                        <ul>
                            <li>Оборудование студии предоставляется для использования в пределах репетиционной комнаты. Для использования дополнительного оборудования может потребоваться дополнительная плата.</li>
                            <li>Вход в репетиционную комнату с напитками в неплотно закрывающейся таре категорически запрещен.</li>
                            <li>Ставить что - либо/класть вещи на оборудование запрещено.</li>
                            <li>После репетиции необходимо убрать громкость на приборах. Затем отключить личный инструмент</li>
                            <li>Отлючать после этого оборудование не нужно.</li>
                        </ul>
                        </li>
                        <li>
                        <strong>Чистота и порядок:</strong>
                        <ul>
                            <li>После завершения репетиции оставьте студию в чистоте. Уберите мусор, уберите личные вещи.</li>
                            <li>Убедитесь, что все оставшиеся материалы, инструменты и оборудование находятся на своих местах.</li>
                        </ul>
                        </li>
                        <li>
                        <strong>Безопасность:</strong>
                        <ul>
                            <li>Не допускается использование пиротехнических средств, открытого огня или веществ, которые могут повредить оборудование или создать угрозу безопасности.</li>
                            <li>В студии запрещено употребление алкоголя и наркотических веществ.</li>
                        </ul>
                        </li>
                        <li>
                        <strong>Уважение:</strong>
                        <ul>
                            <li>Обращайтесь с коллегами и персоналом студии с уважением.</li>
                        </ul>
                        </li>
                        <li>
                        <strong>Оборудование и инструменты:</strong>
                        <ul>
                            <li>Пользуйтесь инструментами и оборудованием в рамках установленных правил. Если у вас есть свои инструменты, убедитесь, что они соответствуют стандартам безопасности.</li>
                            <li>Запрещается приносить в студию опасные или запрещенные предметы.</li>
                        </ul>
                        </li>
                        <li>
                        <strong>Ответственность:</strong>
                        <ul>
                            <li>За ваши личные вещи студия ответственности не несет. Рекомендуем не оставлять ценные предметы без присмотра.</li>
                            <li>В случае повреждения или потери личных вещей, студия не несет ответственности.</li>
                        </ul>
                        </li>
                        <li>
                        <strong>Звуковая запись:</strong>
                        <ul>
                            <li>Пожалуйста, предварительно согласуйте с администрацией студии, если вы хотите записать репетицию или использовать видео- или аудиооборудование студии.</li>
                        </ul>
                        </li>
                        <li>
                        <strong>Продление репетиции:</strong>
                        <ul>
                            <li>Если вы хотите продлить время репетиции, заранее согласуйте это с администрацией. Продление возможно только в случае наличия свободного времени в графике студии.</li>
                        </ul>
                        </li>
                        <li>
                        <strong>Ответственность за соблюдение правил:</strong>
                        <ul>
                            <li>Каждый участник репетиции должен следить за соблюдением этих правил. В случае их нарушения администрация вправе приостановить репетицию и выставить штраф.</li>
                        </ul>
                        </li>
                    </ol>
                </div>
            </div>
        </>
    )
}

export default Rules;